export const STATUS_STYLES = {
  good: { color: 'var(--ts-status-success)', label: 'On Track' },
  warning: { color: 'var(--ts-status-warning)', label: 'Running Late' },
  error: { color: 'var(--ts-status-error)', label: 'Overdue' },
};

export const getStatusStyle = (badgeStatus) =>
  STATUS_STYLES[badgeStatus] ?? STATUS_STYLES.good;
